export enum BazaDwollaDistributionPaymentSource {
    NC = 'NC',
    Dwolla = 'Dwolla',
}

export const bazaDwollaDistributionReprocessablePaymentSources: Array<BazaDwollaDistributionPaymentSource> = [BazaDwollaDistributionPaymentSource.Dwolla];
